import React from "react";
import NoteDetails from "./NoteDetails";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { OPERATION_STATUS } from "../../config/axios.init";
import withHOC from "../../HOC/HOC";
import { getNotesAction, getNoteTypesAction, getUserRolesAction, setNotesRefAction } from "./NoteDetailsAction";
import Utility from "../../utils/Utility";
import { DEFAULT_PAGINATION_ACTIVE_PAGE, DEFAULT_PAGINATION_RECORDS_COUNT } from "../CustomUIComponents/Pagination/PaginationConstants";
import LoadingModal from "../CustomUIComponents/LoadingModal/LoadingModal";
import { Button, Col } from "react-bootstrap";
import { Strings } from "../../resources/i18n/i18n";
import { setSearchFilterAction } from "../../constants/Action";
import { ANALYST_LOAN_DETAIL_FILTER, APPROVAL_DASHBOARD_FILTER, DAILY_STATUS_FILTER, FLR_SEARCH_FILTER, LOAN_DETAIL_FILTER, LOAN_PORTFOLIO_FILTER, MINIMART_LIST_FILTER, PERSON_DAILY_STATUS_FILTER, SEARCH_FILTER_PAGES, SLR_SEARCH_FILTER, SPED_L1_FILTER, SPED_L2_FILTER, WORKLOAD_MANAGEMENT_FILTER } from "../../constants/appConstants";
import { dowloadedAction } from "../../constants/Action";
import fileDownload from "js-file-download";
import { NOTE_TYPE_CONTEXT } from "../../constants/appConstants";
import UserNotification from "../CustomUIComponents/UserNotification/UserNotification";
import {setMinimartDetailsActiveTab } from "../MinimartDetails/MiniMartDetailsAction";
class NoteDetailsContainer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            searchFilter: {},
            showLoader: false,
            userRoles: [],
            noteTypes: ["noteType"],
            refId: props.location.state ? props.location.state.refId : this.props.noteRef.refId,
            noteTypeContext: props.location.state ? props.location.state.noteTypeContext : this.props.noteRef.noteTypeContext,
            numberOfPages: DEFAULT_PAGINATION_RECORDS_COUNT,
            errorMessage: "",
            rows: [],
            isError: false,
        };
    }

    componentDidMount() {
        this.getUserRoles();
        this.getNoteTypes(this.state.noteTypeContext);

        if (
          this.props.location.state &&
          this.props.location.state.refId &&
          this.props.location.state.noteTypeContext
        ) {
          this.props.setNotesRefAction(
            {
              refId: this.props.location.state.refId,
              noteTypeContext:
                this.props.location.state.noteTypeContext,
            }
          );
        }
    }
  componentWillUnmount() {
    //NOSONAR
    if (
      this.props.searchPage === SEARCH_FILTER_PAGES.MINIMART_LIST &&
      !this.props.selectedFeature?.urls.includes(
        this.props.history.location.pathname
      )
    ) {
      this.props.setSearchFilterAction(
        SEARCH_FILTER_PAGES.MINIMART_LIST,
        {
          ...MINIMART_LIST_FILTER,
        }
      );
    }
    if (
      this.props.searchPage ===
      SEARCH_FILTER_PAGES.APPROVAL_DASHBOARD &&
      !this.props.selectedFeature?.urls.includes(
        this.props.history.location.pathname
      )
    ) {
      this.props.setSearchFilterAction(
        SEARCH_FILTER_PAGES.APPROVAL_DASHBOARD,
        {
          ...APPROVAL_DASHBOARD_FILTER,
        }
      );
    }

    if (
      this.props.searchPage === SEARCH_FILTER_PAGES.SPED_L2 &&
      !this.props.selectedFeature?.urls.includes(
        this.props.history.location.pathname
      )
    ) {
      this.props.setSearchFilterAction(SEARCH_FILTER_PAGES.SPED_L1, {
        ...SPED_L1_FILTER,
      });
      this.props.setSearchFilterAction(SEARCH_FILTER_PAGES.SPED_L2, {
        ...SPED_L2_FILTER,
      });
    }
    if (
      this.props.searchPage === SEARCH_FILTER_PAGES.LOAN_PORTFOLIO &&
      !this.props.selectedFeature?.urls.includes(
        this.props.history.location.pathname
      )
    ) {
      this.props.setSearchFilterAction(
        SEARCH_FILTER_PAGES.LOAN_PORTFOLIO,
        { ...LOAN_PORTFOLIO_FILTER }
      );
    }

    if (
      this.props.searchPage ===
      SEARCH_FILTER_PAGES.SECOND_LEVEL_REPORT &&
      !this.props.selectedFeature?.urls.includes(
        this.props.history.location.pathname
      )
    ) {
      this.props.setSearchFilterAction(
        SEARCH_FILTER_PAGES.FIRST_LEVEL_REPORT,
        { ...FLR_SEARCH_FILTER }
      );
      this.props.setSearchFilterAction(
        SEARCH_FILTER_PAGES.SECOND_LEVEL_REPORT,
        { ...SLR_SEARCH_FILTER }
      );
    }
    if (
      this.props.searchPage ===
      SEARCH_FILTER_PAGES.PERSON_DAILY_STATUS &&
      !this.props.selectedFeature?.urls.includes(
        this.props.history.location.pathname
      )
    ) {
      this.props.setSearchFilterAction(
        SEARCH_FILTER_PAGES.DAILY_STATUS,
        { ...DAILY_STATUS_FILTER }
      );
      this.props.setSearchFilterAction(
        SEARCH_FILTER_PAGES.PERSON_DAILY_STATUS,
        { ...PERSON_DAILY_STATUS_FILTER }
      );
    }

    // loan approval
    if (
      this.props.searchPage === SEARCH_FILTER_PAGES.LOAN_DETAIL &&
      !this.props.selectedFeature?.urls.includes(
        this.props.history.location.pathname
      )
    ) {
      this.props?.setMinimartDetailsActiveTab(null);
      this.props.setSearchFilterAction(
        SEARCH_FILTER_PAGES.LOAN_DETAIL,
        { ...LOAN_DETAIL_FILTER }
      );
    }
    if (
      this.props.searchPage ===
      SEARCH_FILTER_PAGES.WORKLOAD_MANAGEMENT &&
      !this.props.selectedFeature?.urls.includes(
        this.props.history.location.pathname
      )
    ) {
      this.props.setSearchFilterAction(
        SEARCH_FILTER_PAGES.WORKLOAD_MANAGEMENT,
        { ...WORKLOAD_MANAGEMENT_FILTER }
      );
    }
    if (
      this.props.searchPage ===
      SEARCH_FILTER_PAGES.ANALYST_LOAN_DETAIL &&
      !this.props.selectedFeature?.urls.includes(
        this.props.history.location.pathname
      )
    ) {
      this.props.setSearchFilterAction(
        SEARCH_FILTER_PAGES.ANALYST_LOAN_DETAIL,
        { ...ANALYST_LOAN_DETAIL_FILTER }
      );
    }
  }
    handleNoteSearchFilter = (searchFilterObject) => {
        this.setState({
            showLoader: true,
            searchFilter: {
                rl: searchFilterObject.notesSearchCriteria.refId,
                ntc: searchFilterObject.notesSearchCriteria.noteTypeContext,
                ty: searchFilterObject.notesSearchCriteria.noteType,
                ur: searchFilterObject.notesSearchCriteria.userRole,
                fromDate: searchFilterObject.notesSearchCriteria.fromDate,
                toDate: searchFilterObject.notesSearchCriteria.toDate,
                offset: searchFilterObject.offset,
                limit: searchFilterObject.limit
            }
        })
        let filteredsearchFilterObject = {
            notesSearchCriteria: {
                contextRefId: searchFilterObject.notesSearchCriteria.refId,
                noteTypeContext: searchFilterObject.notesSearchCriteria.noteTypeContext,
                noteType: searchFilterObject.notesSearchCriteria.noteType,
                userRole: searchFilterObject.notesSearchCriteria.userRole,
                fromDate: Utility.convertDateIntoMiliSeconds(searchFilterObject.notesSearchCriteria.fromDate),
                toDate: Utility.convertDateIntoMiliSeconds(searchFilterObject.notesSearchCriteria.toDate)
            },
            offset: searchFilterObject.offset ? searchFilterObject.offset - 1 : DEFAULT_PAGINATION_ACTIVE_PAGE - 1,
            limit: searchFilterObject.limit
        }
        getNotesAction(filteredsearchFilterObject, (responsedata) => {
            if (responsedata.status === OPERATION_STATUS.SUCCESS) {
                this.setState({
                    numberOfPages: responsedata.data.data.numberOfPages,
                    showLoader: false,
                    errorMessage: "",
                    rows: responsedata.data.data.list
                });
            } else {
                this.setState({
                    errorMessage: responsedata.error.message,
                    showLoader: false,
                });

            }
        });

    }

    getUserRoles = (isAddUser = false) => {
        this.setState({ showLoader: true });
        getUserRolesAction(isAddUser, (response) => {
            this.setState({ showLoader: false });
            if (response.status === OPERATION_STATUS.SUCCESS) {
                this.setState({
                    userRoles: response.data.data.roles,
                });
            }
        });
    };
    getNoteTypes = (noteTypeContext) => {
        this.setState({ showLoader: true });
        getNoteTypesAction(noteTypeContext, (response) => {
            if (response.status === OPERATION_STATUS.SUCCESS) {
                this.setState({
                    showLoader: false,
                    noteTypes: [...this.state.noteTypes, ...response.data.data],
                })
            }
        })
    }
    handleBackButtonClick = () => {
        this.props.history.goBack();
    };

    downloadNotes = (url, searchFilterObject, fileType) => {
        this.setState({ showLoader: true, isError: false });
        let requestData = {
            notesSearchCriteria: {
                contextRefId: searchFilterObject.notesSearchCriteria.contextRefId,
                noteTypeContext: searchFilterObject.notesSearchCriteria.noteTypeContext,
                noteType: searchFilterObject.notesSearchCriteria.noteType,
                userRole: searchFilterObject.notesSearchCriteria.userRole,
                fromDate: Utility.convertDateIntoMiliSeconds(searchFilterObject.notesSearchCriteria.fromDate),
                toDate: Utility.convertDateIntoMiliSeconds(searchFilterObject.notesSearchCriteria.toDate)
            },
            offset: searchFilterObject.offset ? searchFilterObject.offset - 1 : DEFAULT_PAGINATION_ACTIVE_PAGE - 1,
            limit: searchFilterObject.limit
        }
        let noteDocumentHeader
        if(searchFilterObject.notesSearchCriteria.noteTypeContext === NOTE_TYPE_CONTEXT.MINIMART){
            noteDocumentHeader = Strings("MINIMART_NOTES_REPORT")
        }
        else{
            noteDocumentHeader = Strings("LOAN_NOTES_REPORT")
        }

        dowloadedAction(
            url,
            requestData,
            (response) => {
                if (response.status === OPERATION_STATUS.SUCCESS) {
                    if (Utility.checkBlobTypeForFileDownload(response.data.type)) {
                        fileDownload(
                            response.data,
                            noteDocumentHeader +
                            "-" +
                            Utility.getReportFormattedDateString(
                                Utility.convertDateIntoMiliSeconds(new Date())
                            ) +
                            Utility.getFileType(fileType)
                        );
                        this.setState({
                            showLoader: false,
                        });
                    }
                    else {
                        this.setState({
                            showLoader: false,
                            isError: true,
                            errorMessage: Strings("NoRecordsFound"),
                        })
                    }
                }
                else {
                    this.setState({
                        showLoader: false,
                        errorMessage: response.error.message,
                    })
                }
            },
            "NotesReports"
        )
    }

    render() {
        return (
            <div>
                <LoadingModal showLoadingModal={this.state.showLoader} />
                {this.state.isError && (
                    <UserNotification
                        key='Error'
                        userNotificationObj={{
                            message: Strings(this.state.errorMessage),
                            level: "error",
                        }}
                    />
                )}
                <NoteDetails
                    userRoles={this.state.userRoles}
                    searchFilter={this.props.searchFilter}
                    noteTypes={this.state.noteTypes}
                    handlNoteSearchFilter={this.handleNoteSearchFilter}
                    refId={this.state.refId}
                    noteTypeContext={this.state.noteTypeContext}
                    rows={this.state.rows}
                    numberOfPages={this.state.numberOfPages}
                    downloadNotes={this.downloadNotes}
                />
                <Col md={1} className='alignCenter ps-0 pt-2'>
                    <Button
                        className='buttonBorder'
                        onClick={this.handleBackButtonClick}
                    >
                        {Strings("Back").toUpperCase()}
                    </Button>
                </Col>
            </div>

        )
    }
}

const mapStateToProps = (state) => (
    {
    searchFilter: state.searchFilterReducer.notesSearchFilter,
    searchPage: state.searchFilterReducer.searchPage,
    selectedFeature: state.sidebarReducer.selectedFeature,
    noteRef: state.notesRefReducer.NotesRef
});

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        getUserRolesAction,setSearchFilterAction, setNotesRefAction, setMinimartDetailsActiveTab
    }, dispatch);
}

const NotesDetailsWrapper = withHOC(NoteDetailsContainer);

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(NotesDetailsWrapper);